var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-16",staticStyle:{"width":"50%"}},[_c('region-menu-header',{attrs:{"name":"Sediment","icon":'mdi-water-percent',"disable-region-menu":true,"disable-data-request":true}}),_c('v-divider'),_c('div',{staticClass:"mt-5 ml-10"},[_c('SedimentTool')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }